import moment from "moment";

import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";

export default function FormCalendar(props) {
  const {
    className,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true },
    data: {
      name,
      placeholder = "",
      minDate,
      maxDate,
      view = "date",
      dateFormat = "yy/mm/dd",
      mask = "9999/99/99",
      showTime = false,
      showSeconds = false,
      showIcon = true,
      disabled = false,
    },
  } = props;

  const onChange = (e, field) => {
    let value = e.value;
    if (showTime) {
      value = value ? moment(value).format("YYYY/MM/DD HH:mm") : null;
    } else {
      value = value ? moment(value).format("YYYY/MM/DD") : null;
    }

    field.onChange(value);

    if (isSubmitted) {
      trigger();
    } else {
      trigger(field.name);
    }
  };

  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <div className={classNames("flex align-items-center", className)}>
            <Calendar
              id={field.name}
              className={classNames(
                { "p-invalid": fieldState.invalid },
                "w-full"
              )}
              {...field}
              value={field.value ? new Date(field.value) : null}
              onChange={(e) => onChange(e, field)}
              placeholder={placeholder}
              minDate={minDate ? new Date(minDate) : null}
              maxDate={maxDate ? new Date(maxDate) : null}
              view={view}
              dateFormat={dateFormat}
              disabled={!isEdit || disabled}
              showTime={showTime}
              showSeconds={showSeconds}
              // mask={showTime ? `${mask} 99:99` : mask}
              showIcon={!disabled && showIcon}
              showButtonBar
              readOnlyInput
            />
          </div>
        )}
      />
    </>
  );
}
